import { action } from 'easy-peasy';
import { IActionSetAvatar } from '../types';

const setAvatar: IActionSetAvatar = action((state, avatarUrl) => {
  state.current.photo = avatarUrl;
});

export default setAvatar;
